import { ref } from 'vue';
import { useStore } from 'vuex';
import { HandleUploadStatus } from './uploadConfig';
import uploadManager from './uploadManager';

export default function handleUpload(
  props,
  context,
  type = 'batchUploadAudioAndIrc',
  uploadParams = {}
) {
  const uploadFileList = ref([]); // 上传文件的列表
  const operationKey = ref(''); // 操作key
  const store = useStore();

  // 上传成功之后刷新页面和用户信息数据
  function refresh() {
    store.dispatch('getUserInfo');
    context.emit('update');
  }
  function canBeforeUpload() {
    return operationKey.value === HandleUploadStatus.Init;
  }
  function rejectBeforeUpload() {
    operationKey.value = HandleUploadStatus.Handled;
  }
  // 上传前的处理
  const beforeUpload = (file, fileList) => {
    if (canBeforeUpload()) {
      uploadManager.beforeUpload({
        fileList,
        type,
        params: { columnKey: props.columnKey, ...uploadParams },
        callback: refresh,
      });
      rejectBeforeUpload();
    }
  };

  // 自定义上传动作
  const customRequest = () => {};
  // 点击上传按钮:生成新的key,是添加字幕时处理已选音频
  function getUploadFileOperationKey() {
    operationKey.value = HandleUploadStatus.Init;
  }
  return {
    getUploadFileOperationKey,
    uploadFileList,
    beforeUpload,
    customRequest,
  };
}
